<template>
  <div>
    <div v-if="this.active != 1" class="mb-2">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-if="this.active < 3"> <a href="" @click.prevent="previous">Back</a></el-breadcrumb-item>
        <el-breadcrumb-item>Document</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-form v-if="active === 1">
      <div class="card card-with-shadow border-0 h-100 employee-preview-card">
        <div class="card-body position-relative d-flex flex-column">
          <div class="row">
            <div class="col-sm-12 col-md-12 breadcrumb-side-button">
              <div class="float-md-right mb-3">
                <el-tooltip
                  placement="top"
                  :effect="theemMode.darkMode == true ? 'light' : 'dark'"
                  :content="$t('instruction')">
                    <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    data-toggle="modal"
                    @click="instructionOpen">
                    <!-- {{ $t("instruction") }} -->
                    <app-icon name="book-open" />
                  </button>
                </el-tooltip>
                <el-tooltip
                  placement="top"
                  :effect="theemMode.darkMode == true ? 'light' : 'dark'"
                  :content="$t('print_detail')">
                  <button
                    type="button" 
                    @click.prevent="generateReport" 
                    class="btn btn-primary btn-sm">Print</button>
                </el-tooltip>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true">
              <div class="alert alert-info" role="alert">
                <button type="button" class="close" @click.prevent="instructionClose">
                  <h5 aria-hidden="true">&times;</h5>
                </button>
                <!-- <hr> -->
                <h5 class="alert-heading"><app-icon name="book-open" /> {{ $t("instructions_about_job_site") }}</h5>
                <p class="mb-0">{{ $t("introduction_job_site_detail") }}</p>
                <strong>Actions:</strong>
                <ul>
                  <li v-if="userRole.role == 'Buyer' || userRole.role == 'Supplier'"><strong>{{ $t("view_document") }} :</strong> {{ $t("view_document_detail") }}</li>
                  <li v-if="userRole.role == 'Buyer' || userRole.role == 'Supplier'"><strong>{{ $t("view_endorsement") }} :</strong> {{ $t("view_endorsement_detail") }}</li>
                  <li v-if="userRole.role != 'Buyer' && userRole.role != 'Supplier'"><strong>{{ $t("endorse") }} :</strong> {{ $t("endorse_document_detail") }}</li>

                </ul>
              </div>
            </div>
          </div>
          <VueHtml2pdf
            :show-layout="false"
            :float-layout="false"
            :enable-download="false"
            :preview-modal="true"
            :paginate-elements-by-height="1400"
            filename="myPDF"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-content-width="100%"
            ref="html2Pdf">
            <section slot="pdf-content">
            <div class="d-flex flex-column">
              <h5
                class="mb-3 mt-3"
                style="font-size: 1.15rem; color: var(--job-title-color)"
              >
                {{ site.title }}

              </h5>

              <p class="mb-3 font-size-90">{{ site.description }}</p>
              <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <p class="mb-3">
                    <b>{{ $t("start_date") }}</b><br>
                    {{ site.starting_hours }}
                  </p>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <p class="mb-2">
                    <b>{{ $t("end_date") }}</b> <br> 
                    {{ site.ending_hours }}
                  </p>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <p class="mb-3">
                    <b>{{ $t("site_address") }}</b><br>
                    {{ site.site_address }}
                  </p>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <p class="mb-3">
                    <b>{{ $t("site_info") }}</b><br>
                    {{ site.site_info }}
                  </p>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <p class="mb-3">
                    <b>{{ $t("assignment_structure") }}</b><br>
                    {{ site.assignment_structure }}
                  </p>
                </div>
                <div class="col-12 mt-5">
                  <div class="row" v-if="attach_documents.length > 0">
                    <div class="col-sm-4 col-md-3 col-lg-3 mb-2" v-for="(document, index) in attach_documents" :key="index">
                      <div class="card-body" style="padding: 1rem;">
                        <div class="card card-with-shadow border-0 ">
                          <div class="card-body text-center">
                            <span>
                              <app-icon name="file"/>
                            </span>
                            <h6 class="mt-2 text-center mb-0">
                              {{ document.get_forms.name }}
                            </h6>
                            <small>Uploaded By: {{ document.user.role[0].name }}</small>
                          
                            <div class="text-muted d-flex align-items-start">
                              <div class="media-body d-flex justify-content-center mt-3">
                                <div class="d-flex" v-for="(endorsement,key) in document.site_doc_endorse_users" :key="key">
                                  <el-tooltip
                                    placement="top"
                                    :effect="theemMode.darkMode == true ? 'light' : 'dark'"
                                    :content="endorsement.user.full_name">
                                    <i
                                      v-if="endorsement.status == 1"
                                      class="fa fa-user-check fa-lg mr-1"
                                      style="cursor: pointer;color: green;"
                                    ></i>
                                    <i
                                      v-else
                                      class="fa fa-user-times fa-lg mr-1 "
                                      style="cursor: pointer;color: var(--side-bar-dark-text-color);"></i>
                                  </el-tooltip>
                                </div>
                              </div>
                            </div>
                            <div class="text-center mt-3">
                              <a href="#" @click.prevent="viewDocument(document)"> View Document </a><br>
                              <a v-if="userRole.role != 'Buyer' && userRole.role != 'Supplier'" href="" @click.prevent="endorse(document.pivot)"> Endorse </a>
                              <a v-if="userRole.role == 'Buyer' || userRole.role == 'Supplier'" href="" @click.prevent="vieweEndorse(document.pivot)">View Endorsement </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                    <app-empty-data-block v-if="attach_documents.length == 0" :message="$t('nothing_to_show_message')"/>
                </div>
              </div>
            </div>
            </section>
          </VueHtml2pdf>
        </div>
      </div>

    </el-form>
    <el-form v-if="active === 2">
      <form-preview :id="formBody" :response="response" :taskId="taskId" :form_revision_id="formRevisionId" :form_id="formID" :data="siteUser"></form-preview>
    </el-form>
    <!--Site Document endorsement Modal-->
    <mysite-site-document-endore-modal
      v-if="isSiteDocEndorseModalActive"
      modal-id="endorse-Modal"
      :endorseData="endorseData"
      :refresh="getSite"
      :type="type"
      @close-modal="isSiteDocEndorseModalActive = false"
    />
  </div>
</template>

<script>
import { SITE_INFORMATION, SITE_DOCUMENT_ENDORSE} from "../../../../../../Config/ApiUrl.js";
import { axiosGet } from "../../../../../../Helpers/AxiosHelper.js";

export default {

  name: "Information",
  site: 0,
  data() {
    return {
      instructionShow: false,
      isSiteDocEndorseModalActive: false,
      endorseData: {},
      siteId: this.$attrs['props'].id,
      site: {},
      type: '',
      preloader: true,
      active: 1,
      formBody: 0,
      formID: 0,
      formRevisionId: 0,
      user_id: 0,
      attach_documents: [],
      taskId: 0,
      response: '',
      siteUser: {},
    };
  },
  methods: {
    instructionOpen() {
      this.instructionShow = true;
    },
    instructionClose() {
      this.instructionShow = false;
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    getSite() {
      axiosGet(SITE_INFORMATION + "/" + this.siteId)
        .then((res) => {
          this.site = res.data;
          this.attach_documents = res.data.site_document;
          
        })
        .catch((error) => {
          
        })
        .finally(() => {
          
        });
    },
    viewDocument(documentData) {
      debugger
      this.formBody = documentData.form_body_id;
      this.formID = documentData.form_id;
      this.formRevisionId = documentData.id;
      // this.user_id = documentData.user.id;
      this.siteUser = documentData.user
      this.siteUser.user_id = documentData.user.id

      this.response = 'save_response';
      this.taskId = this.$store.state.sharedData.sharedData.taskId;
      this.active = 2;
    },
    previous() {
      this.active = 1;
    },
    endorse(endorseData) {
      this.endorseData = endorseData;
      this.type = 'endorsement';
      this.isSiteDocEndorseModalActive = true;  
    },
    vieweEndorse(endorseData) {
      this.endorseData = endorseData;
      this.type = 'view_endorsement';
      this.isSiteDocEndorseModalActive = true;  
    },
  },
  mounted() {
    this.getSite();
    // this.getSiteTask(); 
  },
  computed: {
    theemMode() {
      return this.$store.state.theme;
    },
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
